import apiClient from './apiClient'

// Perfiles activos para el formulario de solicitud de acceso (público)
export const getPublicRoles = async () => {
  const response = await apiClient.get('/auth/public-roles/')
  return response.data?.roles || []
}

// Enviar una solicitud de acceso (sin código de invitación)
export const submitAccessRequest = async (data) => {
  const response = await apiClient.post('/auth/access-request/', data)
  return response.data
}

// Enviar código de verificación de email antes de registrar la solicitud
export const sendAccessEmailCode = async (email) => {
  const response = await apiClient.post('/auth/access-request/send-code/', { email })
  return response.data
}

// ── Panel admin ─────────────────────────────────────────────────────
export const getAccessRequests = async (params = {}) => {
  const response = await apiClient.get('/auth/access-requests/', { params })
  return response.data
}

export const approveAccessRequest = async (id, data = {}) => {
  const response = await apiClient.post(`/auth/access-requests/${id}/approve/`, data)
  return response.data
}

export const rejectAccessRequest = async (id, data = {}) => {
  const response = await apiClient.post(`/auth/access-requests/${id}/reject/`, data)
  return response.data
}
